// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"49b974f6","164":"4ae9b2bf","254":"18332ab6","301":"ea59b0f6","444":"90068cd9","453":"e745af0d"}[chunkId] + ".chunk.js";
};